module.exports = __webpack_public_path__ + "0a74da8ff7160f24f156ed10bb3d6fbc.svg";